import Head from 'next/head'
import { useTranslation } from 'hooks/useTranslation'
import { RawBenefits } from 'features/Landings/screens/RawBenefits'

const RawBenefitsLandingPage = () => {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'The best Dog Food for optimal health',
    url: 'https://wefeedraw.com/raw-benefits',
    description: 'The very best dog food for digestive issues, dogs with allergies, and more.',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@type': 'WebPage',
            name: 'Dog Food for Digestive Issues',
            url: 'https://wefeedraw.com/raw-benefits#raw-benefits-1',
            description: 'Choose the raw diet for dogs with digestion issues.',
            about: {
              '@type': 'CreativeWork',
              name: 'Dog Food for Digestive Issues',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@type': 'WebPage',
            name: 'Best Raw Diet for Dogs with Allergies',
            url: 'https://wefeedraw.com/raw-benefits#raw-benefits-2',
            description: 'Raw food diet recipes for dogs with allergies are here to save the day.',
            about: {
              '@type': 'CreativeWork',
              name: 'Best Raw Diet for Dogs with Allergies',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        },
        {
          '@type': 'ListItem',
          position: 3,
          item: {
            '@type': 'WebPage',
            name: 'Best Dog Food for Skin & Coat Health',
            url: 'https://wefeedraw.com/raw-benefits#raw-benefits-3',
            description: "Shinier coat or less sensitive skin, your pup's glow-up is about to begin.",
            about: {
              '@type': 'CreativeWork',
              name: 'Best Dog Food for Skin & Coat Health',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        },
        {
          '@type': 'ListItem',
          position: 4,
          item: {
            '@type': 'WebPage',
            name: 'Raw Dog Food for Urinary Health',
            url: 'https://wefeedraw.com/raw-benefits#raw-benefits-4',
            description: 'Keep your pup comfortable when they do their business.',
            about: {
              '@type': 'CreativeWork',
              name: 'Raw Dog Food for Urinary Health',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        },
        {
          '@type': 'ListItem',
          position: 5,
          item: {
            '@type': 'WebPage',
            name: 'Dog Food for Weight Loss',
            url: 'https://wefeedraw.com/raw-benefits#raw-benefits-5',
            description: 'Help your dog look and feel their best.',
            about: {
              '@type': 'CreativeWork',
              name: 'Dog Food for Weight Loss',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        },
        {
          '@type': 'ListItem',
          position: 6,
          item: {
            '@type': 'WebPage',
            name: 'Dog Food for Picky Eaters',
            url: 'https://wefeedraw.com/raw-benefits#raw-benefits-6',
            description: 'Even fussy eaters approve of this ingredient list.',
            about: {
              '@type': 'CreativeWork',
              name: 'Dog Food for Picky Eaters',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        }
      ]
    }
  };

  const jsonLdString = JSON.stringify(schema)

  return (
    <>
      <Head>
        <title>{t('raw-benefits:page-title')}</title>
        <meta name="title" content={t('raw-benefits:meta-title')} />
        <meta name="description" content={t('raw-benefits:meta-description')} />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://wefeedraw.com/raw-benefits" />
        <div
          dangerouslySetInnerHTML={{
            __html: `<script type="application/ld+json">${jsonLdString}</script>`,
          }}
        />
      </Head>
      <RawBenefits />
    </>
  )
}

export default RawBenefitsLandingPage
